module.exports = __webpack_public_path__ + "static/media/wcp_ped_rou.47be5169.png";